import { AppointmentStatus } from 'Turn/services/constants';

/**
 * Cac buoc doi status ma dropdown o Appointment List duoc phep hien.
 *
 * Ban o day chi de dung UI. Backend moi la noi chot: endpoint change-status co bang
 * whitelist rieng va tu choi moi cap ngoai bang, ke ca khi goi thang API.
 *
 * Cot status chi lam MOT viec: dua buoi ve NEW khi ai do bam nham. Moi buoc deu tra ve
 * NEW, nen muc trong dropdown ghi "Revert" chu khong ghi ten status dich.
 *
 * NEW khong co buoc nao: no da la trang thai dau, khong co gi de lui. Confirm mot buoi van
 * lam o modal chi tiet lich nhu truoc.
 *
 * Khong bao gio co duong di toi CHECK_IN: check-in tao ticket trong POS nen phai bam nut
 * CHECK-IN. Cung khong co duong toi CANCEL: huy phai qua luong cancel de con nhap ly do.
 * CANCEL khong co duong ra — lich da huy chi de xem.
 */
const ALLOWED: Partial<Record<AppointmentStatus, AppointmentStatus[]>> = {
  [AppointmentStatus.CONFIRMED]: [AppointmentStatus.NEW],
};

/**
 * Go check-in nam ngoai bang tren vi no khong mo cho moi tiem: no xoa ticket trong POS,
 * nen chi bat o nhung tiem da duoc chon. Server van tu choi neu ticket da tinh tien, du
 * tiem co duoc bat hay khong.
 */
const UNDO_CHECK_IN: AppointmentStatus[] = [AppointmentStatus.NEW];

export const STATUS_LABELS: Record<AppointmentStatus, string> = {
  [AppointmentStatus.NEW]: 'New',
  [AppointmentStatus.CONFIRMED]: 'Confirmed',
  [AppointmentStatus.CHECK_IN]: 'Checked-in',
  [AppointmentStatus.FINISH]: 'Finished',
  [AppointmentStatus.CANCEL]: 'Cancelled',
  [AppointmentStatus.DELETED]: 'Deleted',
};

export type StatusStyle = {
  /** Nen khi o dang nut bam duoc (to dac). */
  solid: string;
  /** Nen khi chi de xem (phang, nhat). */
  soft: string;
  /** Chu tren nen soft; tren nen solid luon la trang. */
  softText: string;
  border: string;
};

/**
 * Mau lay tu chinh bang mau dang dung o calendar (`StatusColorSets`) va bang mau nhom tho,
 * de mot buoi da confirm nhin cung mot mau du dang o list hay o calendar.
 */
export const STATUS_STYLES: Record<AppointmentStatus, StatusStyle> = {
  [AppointmentStatus.NEW]: { solid: '#7B7B7B', soft: '#EEEEEE', softText: '#5E5E5E', border: '#CECECE' },
  [AppointmentStatus.CONFIRMED]: { solid: '#0CB76F', soft: '#E8F7F0', softText: '#0A8F57', border: '#A3E7BE' },
  [AppointmentStatus.CHECK_IN]: { solid: '#148CF1', soft: '#E8F3FF', softText: '#0F6FBF', border: '#BEE1FF' },
  [AppointmentStatus.FINISH]: { solid: '#0CB76F', soft: '#E8F7F0', softText: '#0A8F57', border: '#A3E7BE' },
  [AppointmentStatus.CANCEL]: { solid: '#D93939', soft: '#FDECEC', softText: '#C22B2B', border: '#F3C4C4' },
  [AppointmentStatus.DELETED]: { solid: '#D93939', soft: '#FDECEC', softText: '#C22B2B', border: '#F3C4C4' },
};

const FALLBACK_STYLE: StatusStyle = STATUS_STYLES[AppointmentStatus.NEW];

/** Chu tren moi muc cua dropdown. Moi buoc deu ve NEW nen mot chu la du. */
export const REVERT_LABEL = 'Revert';

/**
 * Cau xac nhan khi go check-in. Dat o day de hai cho goi — cot status trong danh sach va
 * chan modal chi tiet lich — luon noi cung mot cau; hai ban sao se lech nhau ngay lan sua
 * dau tien.
 */
export const UNDO_CHECK_IN_CONFIRM = {
  title: 'UNDO CHECK-IN',
  okLabel: 'UNDO CHECK-IN',
  message: 'This deletes the ticket created in POS and sets the appointment back to New.',
};

export type TransitionOptions = {
  /** Tiem nay co duoc phep go check-in khong. Mac dinh khong. */
  allowUndoCheckIn?: boolean;
};

/**
 * Status la (undefined, gia tri khong nam trong enum) tra ve mang rong thay vi nem loi:
 * mot dong du lieu cu khong duoc phep lam hong ca bang.
 */
export const getAllowedTransitions = (
  status?: AppointmentStatus | number | null,
  options?: TransitionOptions,
): AppointmentStatus[] => {
  if (status === undefined || status === null) return [];
  if (status === AppointmentStatus.CHECK_IN) {
    return options?.allowUndoCheckIn ? UNDO_CHECK_IN : [];
  }
  return ALLOWED[status as AppointmentStatus] ?? [];
};

export const getStatusLabel = (status?: AppointmentStatus | number | null): string => {
  if (status === undefined || status === null) return '--';
  return STATUS_LABELS[status as AppointmentStatus] ?? String(status);
};

export const getStatusStyle = (status?: AppointmentStatus | number | null): StatusStyle => {
  if (status === undefined || status === null) return FALLBACK_STYLE;
  return STATUS_STYLES[status as AppointmentStatus] ?? FALLBACK_STYLE;
};
